export default __webpack_public_path__ + "static/media/53t.323fba72.jpg";